import React, { useState } from 'react'

import { CardActionArea } from 'components/Card'
import Icon from 'components/Icon'
import Lightbox from 'components/Lightbox'
import { FixedImage } from 'components/NextImage'
import { useEventContext } from 'context/EventContext'

import NO_SCREENSHOTS_COPY from './constants'

import classes from './Screenshots.module.scss'

/** @type {import('./types').default} */
const Screenshots = ({ listingName = '', screenshots = [] }) => {
  const [lightboxState, setLightboxState] = useState({ toggler: false })
  const eventContext = useEventContext({ name: 'engagement_product_click' })
  const imageUrls = screenshots.map(screenshot => screenshot.url)
  const captions = screenshots.map(screenshot => screenshot.caption)

  const handleOnClose = () => {
    eventContext.sendEvent({
      engagementDestination: 'close-media',
      engagementDetails: 'media',
      name: 'engagement_product_click',
    })
  }

  const lightboxToggleHandler = () => {
    eventContext.sendEvent({
      engagementDestination: 'open-media',
      engagementDetails: 'media',
      name: 'engagement_product_click',
    })

    setLightboxState({
      toggler: !lightboxState.toggler,
    })
  }

  return (
    <>
      {imageUrls && imageUrls.length > 0 ? (
        <>
          <CardActionArea
            className={classes.screenshotContainer}
            role="link"
            tabIndex="0"
            onClick={lightboxToggleHandler}
            onKeyPress={lightboxToggleHandler}
          >
            <FixedImage
              className={classes.screenshotImage}
              title={listingName}
              alt={listingName}
              src={imageUrls[0]}
              sizes={100}
            />
            <div className={classes.screenshotCaption}>
              <Icon icon={['far', 'camera']} className={classes.cameraIcon} />
              {imageUrls.length} {imageUrls.length > 1 ? ` screenshots` : ' screenshot'}
            </div>
          </CardActionArea>
          <Lightbox onClose={handleOnClose} sources={imageUrls} toggler={lightboxState.toggler} captions={captions} />
        </>
      ) : (
        <div className={classes.emptyScreenshotContainer}>
          <Icon icon={['far', 'images']} className={classes.imagesIcon} />
          <div className={classes.emptyScreenshotText}>{NO_SCREENSHOTS_COPY}</div>
        </div>
      )}
    </>
  )
}

export default Screenshots
